/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation LCRRouteDelete($routeId: ID!) {
    LCRRouteDelete(routeId: $routeId) {
        message
        status
    }
} 
`
